import { render, staticRenderFns } from "./CallPeriod.vue?vue&type=template&id=062128ad&scoped=true"
import script from "./CallPeriod.vue?vue&type=script&lang=js"
export * from "./CallPeriod.vue?vue&type=script&lang=js"
import style0 from "./CallPeriod.vue?vue&type=style&index=0&id=062128ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062128ad",
  null
  
)

export default component.exports